export default {
    path: '/admin',
    components: {
        default: () => import(/* webpackChunkName: "admin" */ '../views/ChildContainer'),
        menu: () => import(/* webpackChunkName: "admin-menu" */ '../views/admin/Menu'),
    },
    children: [
        {
            path: '',
            name: 'AdminHome',
            component: () => import(/* webpackChunkName: "admin-home" */ '../views/Home'),
        },
        {
            path: 'organManage',
            name: 'AdminOrganManage',
            component: () => import(/* webpackChunkName: "admin-organ-manage" */ '../views/admin/AdminOrganManage'),
        },
        {
            path: 'collegeManage',
            name: 'AdminCollegeManage',
            component: () => import(/* webpackChunkName: "admin-college-manage" */ '../views/admin/AdminCollegeManage'),
        },
        {
            path: 'studentManage',
            name: 'AdminStudentManage',
            component: () => import(/* webpackChunkName: "admin-student-manage" */ '../views/admin/AdminStudentManage'),
        },
        {
            path: 'expertManage',
            name: 'AdminExpertManage',
            component: () => import(/* webpackChunkName: "admin-expert-manage" */ '../views/admin/AdminExpertManage'),
        },
        {
            path: 'personManage',
            name: 'AdminPersonManage',
            component: () => import(/* webpackChunkName: "admin-person-manage" */ '../views/admin/AdminPersonManage'),
        },
        {
            path: 'userManage',
            name: 'AdminUserManage',
            component: () => import(/* webpackChunkName: "admin-user-manage" */ '../views/admin/AdminUserManage'),
        },
        {
            path: 'courseManage',
            name: 'AdminCourseManage',
            component: () => import(/* webpackChunkName: "admin-course-manage" */ '../views/admin/AdminCourseManage'),
        },
        {
            path: 'projectCourseManage',
            name: 'AdminProjectCourseManage',
            component: () => import(/* webpackChunkName: "admin-project-course-manage" */ '../views/admin/AdminProjectCourseManage'),
        },


        {
            path: 'projectCategoryManage',
            name: 'AdminProjectCategoryManage',
            component: () => import(/* webpackChunkName: "admin-project-category-manage" */ '../views/admin/AdminProjectCategoryManage'),
        },


        {
            path: 'projectBatchManage',
            name: 'AdminProjectBatchManage',
            component: () => import(/* webpackChunkName: "admin-project-batch-manage" */ '../views/admin/ProjectBatchManage'),
        },
        {
            path: 'projectBatchEdit/:batchId',
            name: 'AdminProjectBatchEdit',
            component: () => import(/* webpackChunkName: "admin-project-batch-edit" */ '../views/admin/ProjectBatchEdit'),
        },
        {
            path: 'projectEdit/:projectId',
            name: 'AdminProjectEdit',
            component: () => import(/* webpackChunkName: "admin-project-edit" */ '../views/admin/AdminProjectEdit'),
        },
        {
            path: 'classExecute/:classId',
            name: 'AdminClassExecute',
            component: () => import(/* webpackChunkName: "admin-class-execute" */ '../views/admin/AdminClassExecute'),
        },



        {
            path: 'projectBatchRequirementEdit/:batchId',
            name: 'AdminProjectBatchRequirementEdit',
            component: () => import(/* webpackChunkName: "admin-project-batch-requirement-edit" */ '../views/admin/AdminProjectBatchRequirementEdit'),
        },
        {
            path: 'projectManage/:projectId',
            name: 'AdminProjectManage',
            component: () => import(/* webpackChunkName: "admin-project-manage" */ '../views/admin/AdminProjectManage'),
        },

        {
            path: 'surveyTemplateManage',
            name: 'AdminSurveyTemplateManage',
            component: () => import(/* webpackChunkName: "admin-survey-template-manage" */ '../views/admin/AdminSurveyTemplateManage'),
        },
        {
            path: 'surveyTemplateEdit/:surveyTemplateId',
            name: 'AdminSurveyTemplateEdit',
            component: () => import(/* webpackChunkName: "admin-survey-template-edit" */ '../views/admin/AdminSurveyTemplateEdit'),
        },

        {
            path: 'collegeCityStatistics',
            name: 'AdminCollegeCityStatistics',
            component: () => import(/* webpackChunkName: "admin-college-city-statistics" */ '../views/admin/statistics/CollegeCityStatistics'),
        },
        {
            path: 'projectClassStatistics',
            name: 'AdminProjectClassStatistics',
            component: () => import(/* webpackChunkName: "admin-project-class-statistics" */ '../views/admin/statistics/ProjectClassStatistics'),
        },
        {
            path: 'collegeTeacherStatistics',
            name: 'AdminCollegeTeacherStatistics',
            component: () => import(/* webpackChunkName: "admin-college-teacher-statistics" */ '../views/admin/statistics/CollegeTeacherStatistics'),
        },
        {
            path: 'projectProfessionalStatistics',
            name: 'AdminProjectProfessionalStatistics',
            component: () => import(/* webpackChunkName: "admin-project-professional-statistics" */ '../views/admin/statistics/ProjectProfessionalStatistics'),
        },
        {
            path: 'projectFeedBackStatistics',
            name: 'AdminProjectFeedBackStatistics',
            component: ()=> import(/* webpackChunkName: "admin-project-feedback-statistics" */ '../views/admin/statistics/ProjectFeedBackStatistics'),
        },

        {
            path: 'certificateDataManage',
            name: 'AdminCertificateDataManage',
            component: () => import(/* webpackChunkName: "admin-certificate-data-manage" */ '../views/admin/AdminCertificateDataManage'),
        },
        {
            path: 'lecturerManage',
            name: 'AdminLecturerManage',
            component: () => import(/* webpackChunkName: "admin-person-manage" */ '../views/admin/AdminLecturerManage'),
        },
        {
            path: 'contactManage',
            name: 'AdminContactManage',
            component: () => import(/* webpackChunkName: "admin-person-manage" */ '../views/admin/AdminContactManage'),
        },
        {
            path: 'informManage',
            name: 'AdminInformManage',
            component: () => import(/* webpackChunkName: "admin-inform-manage" */ '../views/admin/AdminInformManage'),
        },
    ]
}